// extracted by mini-css-extract-plugin
module.exports = {"flexStretch":"flex-stretch_flexStretch__39D5n"};